module.exports = __webpack_public_path__ + "img/diverse-workforces@3x.69d3a8a5.webp";